export const DATA_STATE = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  DEFAULT: "DEFAULT",
} as const;

export type DataState = keyof typeof DATA_STATE;
